import { FC, React} from 'external/react'
import { CSSProperties } from 'react'
import './styles.css'

type SelectFieldProps = {
    className?: string
    onChange: (value: string) => void,
    label: string,
    labelStyles?: CSSProperties,
    textAreaStyles?: CSSProperties,
    required?:boolean,
    value?: string
}

export const TextAreaField: FC<SelectFieldProps> = ({ className, onChange, label, labelStyles, textAreaStyles, required, value }) => {

    return (
        <div className={className} style={{display: 'flex', justifyContent: 'center', minHeight: '80px', gap: '8px', width: '100%', flexDirection: 'column'}}>
            <div >
                {required && <span style={{color: 'red'}}>*</span>}
                <label style={{height: '60px', ...labelStyles}}>
                    {label}
                </label>
            </div>
            <div style={{ display: 'flex', width: '100%'}}>
                <textarea 
                    placeholder='Escriba aquí...' 
                    className='textarea'
                    value={value}
                    rows={5}
                    style={{
                        width: '100%', 
                        resize: 'none', 
                        padding: '20px', 
                        minHeight: '40px',
                        ...textAreaStyles
                    }}
                    onChange={(e) => onChange(e.target.value)}>

                </textarea>
            </div>
        </div>
    )
}